import { useRef, useState } from "react";
import useTranslations from "../../../core/i18n/useTranslations";
import Button from "../../../ui-lib/components/Button/Button";
import { PopupContextMenuLinkButton } from "../../../ui-lib/components/Menus/PopupContextMenu/PopupContextMenuLinkButton";
import PrimeModal from "../../../ui-lib/components/PrimeModal/PrimeModal";
import RequestLogModal from "../../Organizations/RequestOrganizationLogModal";
import { OverlayPanel } from "primereact/overlaypanel";
import { DeleteAdministratorModal } from "../AdministratorDetails/DeleteAdministratorModal";
import { useHistory } from "react-router-dom";

const IdentityActions = ({ id }: { id: string }) => {
  const t = useTranslations();
  const history = useHistory();
  const [requestLogModalOpen, setRequestLogModalOpen] = useState(false);
  const [deleteAdminModalOpen, setDeleteAdminModalOpen] = useState(false);

  const contextMenuRef = useRef<OverlayPanel>(null);

  return (
    <>
      <Button
        type="button"
        variant="secondary"
        image="dots-horizontal"
        text={t("Common:other")}
        onClick={(e) => contextMenuRef.current?.toggle(e)}
      />
      <OverlayPanel ref={contextMenuRef} className="actions-overlay">
        <PopupContextMenuLinkButton
          icon="download"
          text={t("Administrator:request_log")}
          onClick={() => setRequestLogModalOpen(true)}
        />
        <PopupContextMenuLinkButton
          icon="trash"
          text={t("Administrator:delete")}
          onClick={() => setDeleteAdminModalOpen(true)}
        />
      </OverlayPanel>
      <PrimeModal
        withHeader
        fixedWidth="576px"
        header={t("Administrator:request_log")}
        isOpen={requestLogModalOpen}
        onClose={() => setRequestLogModalOpen(false)}
      >
        <RequestLogModal
          onClose={() => setRequestLogModalOpen(false)}
          logTarget="Identity"
        />
      </PrimeModal>
      <DeleteAdministratorModal
        isOpen={deleteAdminModalOpen}
        administratorId={id}
        identity
        onDelete={() => history.push("/adminportal/administrators")}
        onClose={() => {
          setDeleteAdminModalOpen(false);
        }}
      />
    </>
  );
};

export default IdentityActions;
